export default __webpack_public_path__ + "static/media/blog-andrology.562ee280.jpg";